module.exports = __webpack_public_path__ + "img/astral-txt_21.49ee01d6.svg";